import React, { Suspense, lazy, useContext, useEffect } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { BuilderPage } from "./pages/BuilderPage";
import { connect } from "react-redux";
import { MyPage } from "./pages/MyPage";
import DashboardPage from "./modules/Dashboard/DashboardPage";
import UserPage from "./modules/User/UserPage";
import { FlitServiceContext } from '../app/services/flitService';
import { HubConnectionBuilder } from '@microsoft/signalr';
import QuotePage from './modules/Quote/QuotePage';
import ShipmentPage from './modules/Shipment/ShipmentPage';
import LocationPage from './modules/Location/LocationPage';
import BusinessEntityPage from './modules/BusinessEntity/BusinessEntityPage';
import FeePage from "./modules/Fee/FeePage";
import InvoicePage from "./modules/Invoice/InvoicePage";
import ConsolPage from "./modules/Consol/ConsolPage";
import AirExpressPage from "./modules/AirExpress/AirExpressPage";
import OneStopQuote from "./modules/Quote/OneStopQuote";

import * as auth from "./modules/Auth/_redux/authRedux";
import { firebaseAuth } from './../firebase'; // ✅ Changed from authClient
import { onAuthStateChanged } from 'firebase/auth'; // ✅ Added

const GoogleMaterialPage = lazy(() =>
  import("./modules/GoogleMaterialExamples/GoogleMaterialPage")
);
const ReactBootstrapPage = lazy(() =>
  import("./modules/ReactBootstrapExamples/ReactBootstrapPage")
);
const ECommercePage = lazy(() =>
  import("./modules/ECommerce/pages/eCommercePage")
);

const mapStateToProps = ({ auth: { authToken } }) => ({
  authToken
});

function BasePage(props) {
  const { flitSvc } = useContext(FlitServiceContext);
  const { authToken } = props;

  useEffect(() => {
    props.requestUser();
  }, []);

  useEffect(() => {
  let hubConnection = null;
  let authUnsubscribe = null;

  // Firebase auth listener (for monitoring only)
  authUnsubscribe = onAuthStateChanged(firebaseAuth, (user) => {
    if (user) {
      console.log('✅ Firebase user:', user.email);
    } else {
      console.log('❌ Firebase user signed out');
    }
  });

  // Setup SignalR connection
  const setupSignalR = async () => {
    try {
      // Create SignalR connection with dynamic token factory
      hubConnection = new HubConnectionBuilder()
        .withUrl(process.env.REACT_APP_SERVER_PUSH_URL, {
          accessTokenFactory: async () => {
            // ✅ Get fresh token every time SignalR needs it
            if (firebaseAuth.currentUser) {
              const token = await firebaseAuth.currentUser.getIdToken();
              console.log('📡 SignalR using Firebase token');
              return token;
            }
            
            const jwtToken = localStorage.getItem('jwt');
            if (jwtToken) {
              console.log('📡 SignalR using WeChat token');
              return jwtToken;
            }
            
            console.warn('⚠️ No token available for SignalR');
            return null;
          }
        })
        .build();

      // Start connection
      await hubConnection.start();
      console.log('✅ SignalR connected to', process.env.REACT_APP_SERVER_PUSH_URL);

      // Event handlers
      hubConnection.on('UpdateActivityLog', (id) => {
        console.log('📨 SignalR: UpdateActivityLog', id);
        flitSvc.updateActivityLog(id);
      });
      
      hubConnection.on('UpdateBusinessEntity', (id) => {
        console.log('📨 SignalR: UpdateBusinessEntity', id);
        props.requestUser();
      });

      // Auto-reconnect on disconnect
      hubConnection.onclose(async () => {
        console.log('🔌 SignalR disconnected, reconnecting in 5s...');
        await new Promise(resolve => setTimeout(resolve, 5000));
        setupSignalR();
      });

    } catch (err) {
      console.error('❌ SignalR error:', err);
      
      // Retry after 5 seconds
      setTimeout(() => {
        setupSignalR();
      }, 5000);
    }
  };

  // Start SignalR when component mounts
  setupSignalR();

  // Cleanup
  return () => {
    console.log('🧹 Cleaning up BasePage');
    
    if (authUnsubscribe) {
      authUnsubscribe();
    }
    
    if (hubConnection) {
      hubConnection.stop();
    }
  };
}, []);
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Redirect exact from="/" to="/dashboard" />
        
        <ContentRoute path="/builder" component={BuilderPage} />
        <ContentRoute path="/my-page" component={MyPage} />
        <Route path="/dashboard" component={DashboardPage} />
        <Route path="/user" component={UserPage} />
        <Route path="/quote" component={QuotePage} />
        <Route path="/shipment" component={ShipmentPage} />
        <Route path="/location" component={LocationPage} />
        <Route path="/businessEntity" component={BusinessEntityPage} />
        <Route path="/fee" component={FeePage} />
        <Route path="/invoice" component={InvoicePage} />
        <Route path="/google-material" component={GoogleMaterialPage} />
        <Route path="/react-bootstrap" component={ReactBootstrapPage} />
        <Route path="/e-commerce" component={ECommercePage} />
        <Route path="/consol" component={ConsolPage} />
        <Route path="/airexpress" component={AirExpressPage} />
        <Route path="/onestop" component={OneStopQuote} />
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}

export default connect(
  mapStateToProps,
  auth.actions
)(BasePage);